export default function SearchExtension(query) {
  if (query && query.length < 3) {
    return Promise.resolve([]);
  }

  return fetch(`/search?term=${query}`)
    .then((resp) => resp.json())
    .then((items) => items.items);
}
